"use client";

import {
  WlkpCompanyEmployerBasicRegistrationDto,
  RegisterCompanyEmployerDto,
  registerCompanyEmployer,
  useWlkpCompanies,
  WlkpCompany,
  WlkpCompanyCard,
} from "@entities/employer";
import { WlkpCompanyEmployerBasicRegistrationForm } from "@features/registration";
import { useClientConfig } from "@providers/app-provider/client-app-provider";
import { RadialProgress } from "@shared/ui";
import { ArrowRightIcon, CheckIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { Button, Checkbox, SearchInput } from "@ubud-ui/react-ui-kit";
import { useState, useTransition } from "react";
import { WlkpCompanyEmployerBasicRegistrationPreview } from "./wlkp-company-employer-basic-registration-preview";
import { WlkpCompanySelectionPreview } from "./wlkp-company-selection-preview";
import { toast } from "sonner";
import { ExclamationCircleIcon } from "@heroicons/react/24/solid";

function RegistrationCardInfo() {
  return (
    <div className="mt-4 bg-gray-100 rounded-lg px-4 py-3 space-y-2">
      <div className="text-gray-500 text-sm font-normal">Instansi Anda</div>
      <div className="font-medium text-base gap-3 flex items-start">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" className="size-5 min-w-5 mt-0.5" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M6.01175 13.8564C6.01429 13.9072 6.00647 13.958 5.98877 14.0057C5.97107 14.0533 5.94385 14.0969 5.90877 14.1338C5.87369 14.1706 5.83149 14.1999 5.78472 14.2199C5.73796 14.2399 5.68761 14.2502 5.63675 14.2501H1.5005C1.33122 14.2504 1.16683 14.1934 1.03407 14.0884C0.901303 13.9833 0.807971 13.8365 0.769249 13.6717C0.745137 13.5589 0.746249 13.4422 0.772504 13.3299C0.798759 13.2176 0.849509 13.1124 0.921124 13.022C1.58282 12.1445 2.46077 11.4536 3.46925 11.0167C3.02649 10.613 2.68691 10.1091 2.47894 9.54721C2.27098 8.9853 2.20068 8.38173 2.27395 7.78707C2.34721 7.1924 2.5619 6.62395 2.90003 6.12931C3.23817 5.63468 3.6899 5.22827 4.2174 4.94413C4.7449 4.65998 5.33281 4.50636 5.93188 4.49615C6.53096 4.48594 7.12376 4.61942 7.66063 4.88542C8.19751 5.15142 8.66284 5.54219 9.01764 6.02501C9.37244 6.50783 9.60638 7.06863 9.69987 7.66046C9.71195 7.74004 9.69769 7.82139 9.65927 7.89213C9.62086 7.96287 9.56039 8.01912 9.48706 8.05233C8.4468 8.53325 7.56581 9.30168 6.94803 10.267C6.33026 11.2322 6.00148 12.3541 6.0005 13.5001C6.0005 13.6201 6.0005 13.7383 6.01175 13.8564ZM23.0742 13.0211C22.4141 12.1446 21.5381 11.454 20.5317 11.0167C20.9745 10.613 21.3141 10.1091 21.5221 9.54721C21.73 8.9853 21.8003 8.38173 21.727 7.78707C21.6538 7.1924 21.4391 6.62395 21.101 6.12931C20.7628 5.63468 20.3111 5.22827 19.7836 4.94413C19.2561 4.65998 18.6682 4.50636 18.0691 4.49615C17.47 4.48594 16.8772 4.61942 16.3404 4.88542C15.8035 5.15142 15.3382 5.54219 14.9834 6.02501C14.6286 6.50783 14.3946 7.06863 14.3011 7.66046C14.289 7.74004 14.3033 7.82139 14.3417 7.89213C14.3801 7.96287 14.4406 8.01912 14.5139 8.05233C15.5542 8.53325 16.4352 9.30168 17.053 10.267C17.6707 11.2322 17.9995 12.3541 18.0005 13.5001C18.0005 13.6201 18.0005 13.7383 17.9892 13.8564C17.9867 13.9072 17.9945 13.958 18.0122 14.0057C18.0299 14.0533 18.0571 14.0969 18.0922 14.1338C18.1273 14.1706 18.1695 14.1999 18.2163 14.2199C18.263 14.2399 18.3134 14.2502 18.3642 14.2501H22.5005C22.6698 14.2504 22.8342 14.1934 22.9669 14.0884C23.0997 13.9833 23.193 13.8365 23.2317 13.6717C23.256 13.5587 23.2549 13.4417 23.2285 13.3292C23.202 13.2167 23.151 13.1115 23.0789 13.0211H23.0742ZM14.7305 17.0692C15.4773 16.4973 16.026 15.7058 16.2997 14.8059C16.5734 13.9059 16.5582 12.9429 16.2563 12.0521C15.9543 11.1612 15.3808 10.3874 14.6164 9.83936C13.852 9.2913 12.935 8.99656 11.9944 8.99656C11.0538 8.99656 10.1368 9.2913 9.3724 9.83936C8.60796 10.3874 8.03448 11.1612 7.73254 12.0521C7.43061 12.9429 7.41541 13.9059 7.68909 14.8059C7.96276 15.7058 8.51154 16.4973 9.25831 17.0692C7.93319 17.6434 6.82668 18.6267 6.10081 19.8751C6.03498 19.9892 6.00032 20.1185 6.00033 20.2502C6.00034 20.3819 6.03501 20.5112 6.10085 20.6252C6.1667 20.7392 6.2614 20.8339 6.37544 20.8997C6.48948 20.9655 6.61883 21.0002 6.7505 21.0001H17.2505C17.3822 21.0002 17.5115 20.9655 17.6256 20.8997C17.7396 20.8339 17.8343 20.7392 17.9001 20.6252C17.966 20.5112 18.0007 20.3819 18.0007 20.2502C18.0007 20.1185 17.966 19.9892 17.9002 19.8751C17.1728 18.6258 16.0642 17.6425 14.7371 17.0692H14.7305Z"
            fill="#6C727F"
          />
        </svg>
        Instansi/Perusahaan yang memiliki WLKP dan memiliki NIB
      </div>
    </div>
  );
}

// Step 1: WLKP Company Search & Selection
function WlkpCompanySearchStep({
  selectedCompany,
  onSelect,
  onBack,
}: {
  selectedCompany?: WlkpCompany | null;
  onSelect: (company: WlkpCompany) => void;
  onBack?: () => void;
}) {
  const [keyword, setKeyword] = useState<string>("");
  const { companies, isLoading } = useWlkpCompanies({ keyword });

  const handleSelect = (company: WlkpCompany) => {
    if (onSelect) {
      onSelect(company);
    }
  };

  return (
    <>
      <div className="space-y-4">
        <SearchInput value={keyword} onSearch={setKeyword} placeholder="Kode WLKP atau NIB" className="text-sm" />
        {companies && companies.length > 0 ? (
          <div className="mt-4 space-y-2">
            {companies.map((company, index) => {
              return (
                <WlkpCompanyCard company={company} key={company.wlkpCode + "-" + index}>
                  <div className="ml-2">
                    {selectedCompany?.wlkpCode === company.wlkpCode ? (
                      <Button disabled className="gap-2 text-sm font-bold" size="sm">
                        Dipilih
                        <CheckIcon className="size-4 min-w-4" />
                      </Button>
                    ) : (
                      <Button className="gap-2 text-sm font-bold" size="sm" onClick={() => handleSelect(company)}>
                        Pilih
                        <ArrowRightIcon className="size-4 min-w-4" />
                      </Button>
                    )}
                  </div>
                </WlkpCompanyCard>
              );
            })}
          </div>
        ) : !isLoading && keyword.length > 0 ? (
          <div className="text-center flex flex-col items-center justify-center mt-4 space-y-2">
            <div className="rounded-full p-4 bg-gray-100 inline-flex items-center justify-center text-center size-16 min-w-16">
              <MagnifyingGlassIcon className="size-6 min-w-6" />
            </div>
            <h4 className="text-lg font-semibold">Data tidak ditemukan</h4>
            <p className="text-sm text-gray-500">
              Tidak ditemukan perusahaan berdasarkan kata kunci di atas, silahkan mengganti kata kunci dengan mengisi kode WLKP atau NIB
              yang sesuai.
            </p>
          </div>
        ) : (
          keyword.length === 0 && (
            <div className="text-center flex flex-col items-center justify-center mt-4 space-y-2">
              <div className="rounded-full p-4 bg-gray-100 inline-flex items-center justify-center text-center size-16 min-w-16">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth={1.5}
                  stroke="currentColor"
                  className="size-7 min-w-7 text-gray-400"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"
                  />
                </svg>
              </div>
              <h4 className="text-lg font-semibold">Cari perusahaan Anda</h4>
              <p className="text-sm text-gray-500">
                Masukkan kode WLKP atau NIB perusahaan Anda pada kolom pencarian di atas untuk menemukan dan memilih perusahaan yang
                terdaftar.
              </p>
            </div>
          )
        )}
        {isLoading && <div className="text-sm text-gray-500 mt-6 text-center">Sedang memuat data...</div>}
      </div>
      {onBack && (
        <div className="mt-6 grid grid-cols-2 gap-3">
          <Button type="button" className="w-full text-sm font-bold" variant="outline" onClick={onBack}>
            Kembali
          </Button>
        </div>
      )}
    </>
  );
}

export function WlkpCompanyEmployerRegistration({ redirectUrl }: { redirectUrl?: string }) {
  const config = useClientConfig();
  const nacoUser = config?.nacoUser;

  const steps = ["Pilih perusahaan WLKP", "Informasi dasar & PIC"];

  const [step, setStep] = useState<number>(0);
  const [isShowPreview, setIsShowPreview] = useState<boolean>(false);

  const [selectedCompany, setSelectedCompany] = useState<WlkpCompany | null>(null);
  const [basic, setBasic] = useState<WlkpCompanyEmployerBasicRegistrationDto | null>(null);

  const [consents, setConsents] = useState([
    { id: "responsible", text: "Saya berwenang mendaftarkan instansi ini sebagai pemberi kerja di Karirhub", checked: false },
    { id: "data_correct", text: "Saya menyatakan data yang diisi adalah benar dan dapat dipertanggungjawabkan.", checked: false },
  ]);

  const handleSelectCompany = (company: WlkpCompany) => {
    setSelectedCompany(company);
    setStep(1);
  };

  const handleSubmitBasic = (payload: WlkpCompanyEmployerBasicRegistrationDto) => {
    setBasic(payload);
    setIsShowPreview(true);
  };

  const handleUpdateConsent = (id: string, check: boolean | "indeterminate") => {
    setConsents((prev) => {
      const newMap = prev.map((it) => {
        if (it.id === id) {
          return {
            ...it,
            checked: check === "indeterminate" ? false : check,
          };
        }

        return it;
      });

      return newMap;
    });
  };

  const handleChangeCompany = () => {
    setIsShowPreview(false);
    setSelectedCompany(null);
    setStep(0);
  };

  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isRegistering, startRegistering] = useTransition();

  const handleRegister = () => {
    if (!selectedCompany || !basic) return;

    setErrorMessage("");
    startRegistering(async () => {
      try {
        const payload: RegisterCompanyEmployerDto = {
          wlkp_code: selectedCompany.wlkpCode,
          industry_id: basic.industry?.value as string,
          pic_name: basic.pic_name,
          pic_id_number: basic.pic_id_number,
          pic_email: basic.pic_email,
          pic_phone: basic.pic_phone,
        };

        const response = await registerCompanyEmployer(payload);

        if (response && typeof response === "object" && "error" in response && response.error) {
          setErrorMessage(
            typeof response.errorDescription === "string"
              ? response.errorDescription
              : typeof response.error === "string"
                ? response.error
                : "Gagal mendaftar sebagai pemberi kerja.",
          );
        } else {
          toast.success("Pendaftaran Pemberi Kerja", {
            description: `🎉 Selamat! Pendaftaran sebagai pemberi kerja telah berhasil.`,
            duration: 3000,
          });
          setTimeout(() => {
            window.location.replace(redirectUrl || "/");
          }, 3000);
        }

        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } catch (error) {
        setErrorMessage(error instanceof Error ? error.message : "Terjadi kesalahan saat mendaftar sebagai pemberi kerja.");
      }
    });
  };

  const getFormStep = () => {
    switch (step) {
      case 0:
      default:
        return <WlkpCompanySearchStep selectedCompany={selectedCompany} onSelect={handleSelectCompany} />;

      case 1:
        return (
          <WlkpCompanyEmployerBasicRegistrationForm
            onSubmit={handleSubmitBasic}
            formValue={{
              industry: basic?.industry || undefined,
              pic_id_number: nacoUser?.username || "",
              pic_email: nacoUser?.email || "",
              pic_name: nacoUser?.name || "",
              pic_phone: nacoUser?.phoneNumber || "",
            }}
          >
            <div className="mt-6 grid grid-cols-2 gap-3">
              <Button
                type="button"
                className="w-full text-sm font-bold"
                variant="outline"
                onClick={() => {
                  setStep(0);
                  setSelectedCompany(null);
                }}
              >
                Kembali
              </Button>
              <Button type="submit" className="w-full text-sm font-bold">
                Daftar
              </Button>
            </div>
          </WlkpCompanyEmployerBasicRegistrationForm>
        );
    }
  };

  // Preview screen
  if (isShowPreview) {
    return (
      <>
        <h1 className="text-xl font-bold">Konfirmasi data pemberi kerja</h1>
        <p className="mt-2 text-sm font-normal text-gray-500">
          Verifikasi membutuhkan waktu minimal 3 hari kerja. Pantau status akun Anda secara berkala atau hubungi kami bila ada pertanyaan.
        </p>
        <RegistrationCardInfo />

        {errorMessage ? (
          <div className="mt-4 bg-red-100 rounded-lg px-4 py-3 space-y-3 text-red-600">
            <h2 className="font-semibold text-sm flex items-center gap-2">
              <ExclamationCircleIcon className="size-5 min-w-5" />
              <span>Terjadi kesalahan</span>
            </h2>
            <div className="text-sm">{errorMessage}</div>
          </div>
        ) : null}

        <div className="mt-6 md:mt-7">
          <WlkpCompanySelectionPreview company={selectedCompany} onChange={handleChangeCompany} />

          <hr className="border-gray-100 -mx-6 md:-mx-10 my-6" />

          <WlkpCompanyEmployerBasicRegistrationPreview basic={basic} onSubmit={setBasic} />

          <hr className="border-gray-100 -mx-6 md:-mx-10 my-6" />

          <div className="space-y-3">
            {consents.map((consent) => {
              return (
                <div className="flex items-center gap-3" key={consent.id}>
                  <Checkbox
                    className="mt-1"
                    id={consent.id}
                    onCheckedChange={(checked) => handleUpdateConsent(consent.id, checked)}
                    checked={consent.checked}
                  />
                  <label htmlFor={consent.id} className="text-sm font-normal cursor-pointer">
                    {consent.text}
                  </label>
                </div>
              );
            })}
          </div>

          <div className="mt-6 grid grid-cols-2 gap-3">
            <Button type="button" className="w-full text-sm font-bold" variant="outline" onClick={() => setIsShowPreview(false)}>
              Kembali
            </Button>
            <Button
              type="button"
              className="w-full text-sm font-bold"
              disabled={!consents.every((it) => it.checked) || isRegistering}
              onClick={handleRegister}
            >
              {isRegistering ? "Sedang mendaftar..." : "Daftar Sekarang"}
            </Button>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <h1 className="text-xl font-bold">Daftar sebagai pemberi kerja</h1>
      <RegistrationCardInfo />
      <div className="mt-6 md:mt-7 space-y-5">
        <div className="flex items-center justify-between flex-wrap gap-4">
          <h4 className="text-base font-bold flex-1">{steps[step]}</h4>
          <div className="flex items-center gap-2 text-sm font-medium text-gray-500">
            <RadialProgress size={16} strokeWidth={3} progress={((step + 1) / steps.length) * 100} />
            Langkah {step + 1}/{steps.length}
          </div>
        </div>
        {getFormStep()}
      </div>
    </>
  );
}
